import { useState } from 'react';

import { Button, PageHeader, SegmentedControl } from '../../components/ui/index.js';

export function SettingsLicense(): JSX.Element {
  const [channel, setChannel] = useState<'stable' | 'beta' | 'edge'>('stable');
  return (
    <div className="inbx-page">
      <PageHeader title="Self-hosted лицензия" />
      <div className="inbx-page__body" style={{ maxWidth: 720 }}>
        <div className="inbx-card">
          <h4 className="inbx-card__title">Лицензия</h4>
          <KV label="Тип" value="Business" />
          <KV label="Домен" value="mysite.ru" />
          <KV label="Операторов" value="до 20" />
          <KV label="Обновления до" value="15 мая 2027" />
          <KV
            label="Статус"
            value={<span className="inbx-pill-badge inbx-pill-badge--success">Активна</span>}
          />
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <Button variant="secondary">Сменить домен</Button>
            <Button variant="primary">Продлить</Button>
          </div>
        </div>

        <div className="inbx-card">
          <h4 className="inbx-card__title">Обновления</h4>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 'var(--inbx-fz-sm)', color: 'var(--inbx-text-tertiary)' }}>
                Текущая версия
              </div>
              <div style={{ fontWeight: 500, fontSize: 'var(--inbx-fz-lg)' }}>v2.4.1</div>
            </div>
            <i
              className="ti-arrow-right"
              style={{ fontSize: 20, color: 'var(--inbx-text-muted)' }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 'var(--inbx-fz-sm)', color: 'var(--inbx-text-tertiary)' }}>
                Доступна
              </div>
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 'var(--inbx-fz-lg)',
                  color: 'var(--inbx-accent)',
                }}
              >
                v2.5.0
              </div>
            </div>
          </div>
          <SegmentedControl
            value={channel}
            onChange={setChannel}
            options={[
              { value: 'stable', label: 'Stable' },
              { value: 'beta', label: 'Beta' },
              { value: 'edge', label: 'Edge' },
            ]}
          />
          <div style={{ marginTop: 12 }}>
            <Button variant="primary">Обновить до v2.5.0</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

function KV({ label, value }: { label: string; value: React.ReactNode }): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        fontSize: 'var(--inbx-fz-md)',
      }}
    >
      <span style={{ color: 'var(--inbx-text-tertiary)' }}>{label}</span>
      <span>{value}</span>
    </div>
  );
}
